import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as Styles from "@universityofmaryland/web-styles-library";
import { createMediaQuery } from "@universityofmaryland/web-utilities-library/styles";
import { truncateTextBasedOnSize } from "@universityofmaryland/web-utilities-library/string";
import { quote } from "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import { createActionIcon } from "../../../atomic/actions/icon.js";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import "../../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../../atomic/assets/image/background.js";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
import { createTextLockupSmallScaling } from "../../../atomic/text-lockup/small-scaling.js";
const classRef = "card-overlay-image";
const createCardOverlayImage = (props) => {
  const {
    isQuote,
    ctaIcon,
    dateSign,
    backgroundImage,
    text,
    imageLoading = "lazy"
  } = props;
  const children = [];
  const wrapperChildren = [];
  const load = () => {
    const sizeElements = () => {
      const textCopy = text?.innerHTML;
      if (text && textCopy) {
        const modifiedText = truncateTextBasedOnSize({
          text: textCopy,
          size: composite.element.offsetWidth
        });
        text.innerHTML = modifiedText;
        if (modifiedText.length >= 220) {
          const assetContainer = composite.element.querySelector(
            `.${imageContainerClass}`
          );
          if (assetContainer) {
            assetContainer.setAttribute("data-size", "large");
          }
        }
      }
    };
    sizeElements();
  };
  let imageContainerClass = null;
  if (ctaIcon && ctaIcon instanceof HTMLElement) {
    children.push(createActionIcon({ ...props, ctaIcon, isThemeLight: false }));
  }
  if (backgroundImage) {
    const imageContainer = createImageBackground({
      element: backgroundImage,
      isScaled: true,
      isGifAllowed: true,
      imageLoading,
      customStyles: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        [`&:before`]: {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
          opacity: 1,
          transition: `opacity 0.5s ease-in-out`,
          background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .55) 60%, rgba(0, 0, 0, 0.9) 100%)"
        },
        [`&[data-size="large"]:before`]: {
          background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .55) 30%, rgba(0, 0, 0, 0.9) 100%)"
        }
      }
    });
    children.push(imageContainer);
    imageContainerClass = imageContainer.element.className;
  }
  if (dateSign) {
    wrapperChildren.push(
      new ElementBuilder().styled(Styles.layout.background.box.white).withStyles({
        element: {
          alignSelf: `flex-start`
        },
        siblingAfter: {
          marginTop: `${token.spacing.min}`
        }
      }).withChild(dateSign).build()
    );
  }
  if (isQuote) {
    const quoteWrapper = new ElementBuilder().withClassName("card-overlay-image-quote-wrapper").withStyles({
      element: {
        width: "41px",
        height: "30px",
        marginBottom: `${token.spacing.xs}`,
        "& svg": {
          fill: `${token.color.red}`
        }
      }
    }).withHTML(quote).build();
    wrapperChildren.push(quoteWrapper);
  }
  wrapperChildren.push(
    createTextLockupSmallScaling({
      ...props,
      isThemeDark: true
    })
  );
  const textContent = new ElementBuilder().withClassName("card-overlay-image-text-content").withStyles({
    element: {
      maxWidth: `${token.spacing.maxWidth.smallest}`,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      zIndex: 9,
      position: "relative",
      [" & * "]: {
        color: `${token.color.white}`
      }
    }
  }).withChildren(...wrapperChildren).build();
  const textWrapper = new ElementBuilder().withClassName("card-overlay-image-text-wrapper").withStyles({
    element: {
      height: "auto",
      paddingRight: `${ctaIcon ? token.spacing["2xl"] : 0}`
    }
  }).withChild(textContent).build();
  const container = new ElementBuilder().withClassName("card-overlay-image-container").withStyles({
    element: {
      position: "relative",
      padding: `${token.spacing.lg} ${token.spacing.md}`,
      paddingTop: `${token.spacing["4xl"]}`,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      minHeight: "360px",
      height: "100%",
      overflow: "hidden",
      ...createMediaQuery(
        "min-width",
        token.media.breakpointValues.medium.min,
        {
          paddingTop: `${token.spacing["8xl"]}`,
          minHeight: `424px`
        }
      ),
      [`@container  (min-width: 600px)`]: {
        paddingLeft: token.spacing.xl,
        paddingRight: token.spacing.xl
      }
    }
  }).withChildren(...children, textWrapper).build();
  const composite = new ElementBuilder().withClassName(classRef).withStyles({
    element: {
      height: "100%",
      containerType: "inline-size",
      [`&:hover, &:focus`]: {
        [`& .${imageContainerClass}:before`]: {
          opacity: 0.7
        },
        ["& img"]: {
          transform: "scale(1.025)",
          transition: "transform 0.5s ease-in-out"
        }
      }
    }
  }).withChild(container).build();
  return {
    ...composite,
    events: {
      load
    }
  };
};
export {
  classRef,
  createCardOverlayImage
};
//# sourceMappingURL=image.js.map
